import React from "react"
import styled, { keyframes } from "styled-components"
import StyledSmallTitle from "../styled/styledSmallTitle"
import { StyledTitle } from "../Title"
import ListOfReasons from "./ListOfReasons"
import logo from "../../images/logo/logoShadow.svg"

const pulsating = keyframes`
0% {
    -moz-box-shadow: 0 0 0 0 rgba(249, 214, 193, 0.4);
    box-shadow: 0 0 0 0 rgba(249, 214, 193, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 25px rgba(249, 214, 193, 0);
      box-shadow: 0 0 0 25px rgba(249, 214, 193, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(249, 214, 193, 0);
      box-shadow: 0 0 0 0 rgba(249, 214, 193, 0);
  }
`

const StyledSection = styled.section`
  background-color: #fffcfa;
  padding: 64px 16px 32px;
  @media (min-width: 768px) {
    padding: 120px 16px;
    margin-bottom: -350px;
  }
  @media (min-width: 900px) {
    max-width: 768px;
    margin: 0 auto -350px;
  }
  @media (min-width: 1024px) {
    max-width: 900px;
  }
`
const ExtendSmallTitle = styled(StyledSmallTitle)`
  @media (min-width: 768px) {
    text-align: center;
  }
`

const ExtendStyledTitle = styled(StyledTitle)`
  @media (min-width: 768px) {
    text-align: center;
    width: 65%;
    margin: 0 auto 44px;
    &::after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
`

const Container = styled.div`
  @media (min-width: 768px) {
    position: relative;
  }
  @media (min-width: 900px) {
    max-width: 768px;
    margin: 0 auto;
  }
  @media (min-width: 1024px) {
    width: 770px;
    height: 770px;
    margin: 0 auto;
  }
`

const BigCircle = styled.div`
  border-radius: 50%;
  width: 75%;
  height: 75%;
  border: 1px solid #f9d6c1;
  display: none;
  position: absolute;
  left: 50%;
  top: 25%;
  transform: translate(-50%, calc(-50% - 19px));
  opacity: 0.3;
  animation: ${pulsating} 2s 1s infinite;
  @media (min-width: 768px) {
    display: block;
  }
`
const SmallCircle = styled.div`
  border-radius: 50%;
  width: 35%;
  height: 35%;
  border: 1px solid #f9d6c1;
  display: none;
  position: absolute;
  left: 50%;
  top: 25%;
  transform: translate(-50%, calc(-50% - 19px));
  opacity: 0.7;
  animation: ${pulsating} 2s infinite;
  @media (min-width: 768px) {
    display: block;
  }
`
const Logo = styled.img`
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -35px) scale(2);
  display: none;
  @media (min-width: 768px) {
    display: block;
  }
`

const Reasons = () => {
  return (
    <StyledSection>
      <ExtendSmallTitle>DLACZEGO WARTO</ExtendSmallTitle>
      <ExtendStyledTitle>
        <span>
          6 po<em>www</em>odów, dlaczego warto
        </span>{" "}
        podjąć współpracę z Nis Media.
      </ExtendStyledTitle>
      <Container>
        <ListOfReasons />
        <BigCircle />
        <SmallCircle />
        <Logo src={logo} alt="Logo Nis Media" title="Nis Media - agencja interaktywna" />
      </Container>
    </StyledSection>
  )
}

export default Reasons
